import type { CardType } from '../models/card-model';
import type { ChartType } from '../models/chart-config.model';
import type { LayoutConfig } from '../models/layout.model';
import { CARD_GRID_COLUMNS, getCardGridSize } from './card-grid-size.util';
import { deriveLayoutIdForPage } from './page-layout-id.util';

/** The card fields the one-slot layout needs. */
export interface EmbedCardLayoutInput {
	pageId: string;
	cardId: string;
	cardType: string;
	chartType: string | null;
}

/**
 * One-slot layout for MCP `view_card` (JEP-10855): the card full width and locked,
 * at its card type's default height. Built from the embed alone; no report or page is
 * loaded, so a card on a report renders the same as an exploration card.
 */
export function embedCardLayout(card: EmbedCardLayoutInput): LayoutConfig {
	const cardType = card.cardType as CardType;
	return {
		layoutId: deriveLayoutIdForPage(card.pageId),
		pageId: card.pageId,
		order: 1,
		cards: [
			{
				cardId: card.cardId,
				cardType,
				...(card.chartType
					? { chartType: card.chartType as ChartType }
					: {}),
				x: 0,
				y: 0,
				w: CARD_GRID_COLUMNS,
				h: getCardGridSize(cardType).defaultH,
				noMove: true,
				noResize: true,
				locked: true,
			},
		],
	};
}
